import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  IconButton,
} from "@mui/material";
import SubCategory from "./SubCategory";
import EnableSwitch from "./EnableSwitch";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const CategoriesRows = ({ category, index }) => {
  const [openSub, setOpenSub] = useState(false);

  return (
    <>
      <TableRow key={index}>
        <TableCell>
          <Box className="property_name">
            <Box className="td-wrapper">
              <Typography variant="p" component="p" className="table-text">
                {category?.name}
              </Typography>
            </Box>
          </Box>
        </TableCell>

        <TableCell>
          <Box className="td-wrapper">
            {/* <Typography variant="p" component="p" className="table-text"> */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "nowrap",
                gap: "3px",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <EnableSwitch
                value={category}
                api={`goal-categories`}
                setOpenSub={setOpenSub}
              />
              {category?.subCategory?.length > 0 ? (
                openSub ? (
                  <IconButton onClick={() => setOpenSub(false)}>
                    <KeyboardArrowUpIcon />
                  </IconButton>
                ) : (
                  <IconButton onClick={() => setOpenSub(true)}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                )
              ) : null}
            </Box>
            {/* </Typography> */}
          </Box>
        </TableCell>
      </TableRow>
      {category?.subCategory?.length > 0 ? (
        <SubCategory
          open={openSub}
          subCategory={category.subCategory}
          index={`sub-${index}`}
        />
      ) : null}
    </>
  );
};

export default CategoriesRows;
